window.Products.Clothing.LoungePants = function() {
};
window.Products.Clothing.LoungePants.inherits(window.Products.Clothing.Clothing);
window.Products.Clothing.LoungePants.dpi = 150;
window.Products.Clothing.LoungePants.has_3d = true;
window.Products.Clothing.LoungePants.id = 97;
window.Products.Clothing.LoungePants.slug = 'lounge-pants';
window.Products.Clothing.LoungePants.use_glb = true;

window.Products.Clothing.LoungePants.prototype.outsideObject = 2;
window.Products.Clothing.LoungePants.prototype.insideObject = 1;
window.Products.Clothing.LoungePants.prototype.elasticObject = 3;
window.Products.Clothing.LoungePants.prototype.elasticInsideObject = 0;

window.Products.Clothing.LoungePants.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	me.loadEnvMap(function(){
		modelViewer.object.children[me.outsideObject].material.envMap = me.envMap;
		modelViewer.object.children[me.outsideObject].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
		modelViewer.object.children[me.outsideObject].material.needsUpdate = true;
		modelViewer.object.children[me.outsideObject].material.envMap.needsUpdate = true;

		me.updateThreeTexture(modelViewer);

		modelViewer.object.children[me.outsideObject].material.side = THREE.DoubleSide;

		modelViewer.object.children[me.insideObject].material.side = THREE.FrontSide;
		modelViewer.object.children[me.insideObject].material.aoMapIntensity = 1.25;
		modelViewer.object.children[me.insideObject].material.transparent = true;
		modelViewer.object.children[me.insideObject].material.opacity = 0.6;

		modelViewer.object.children[me.elasticInsideObject].material.side = THREE.FrontSide;
		modelViewer.object.children[me.elasticInsideObject].material.envMap = me.envMap;
		modelViewer.object.children[me.elasticInsideObject].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
		modelViewer.object.children[me.elasticInsideObject].material.needsUpdate = true;
		modelViewer.object.children[me.elasticInsideObject].material.envMap.needsUpdate = true;
		modelViewer.object.children[me.elasticInsideObject].material.aoMapIntensity = 0.5;
		modelViewer.object.children[me.elasticInsideObject].material.transparent = true;
		modelViewer.object.children[me.elasticInsideObject].material.opacity = 0.95;

		modelViewer.object.children[me.elasticObject].material.side = THREE.DoubleSide;
		modelViewer.object.children[me.elasticObject].material.envMap = me.envMap;
		modelViewer.object.children[me.elasticObject].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
		modelViewer.object.children[me.elasticObject].material.needsUpdate = true;
		modelViewer.object.children[me.elasticObject].material.envMap.needsUpdate = true;
		modelViewer.object.children[me.elasticObject].material.aoMapIntensity = 0.5;

		modelViewer.object.position.y = -0.7;
		modelViewer.object.rotation.y = Math.PI;
		modelViewer.camera.position.y = 1;
	});
};

window.Products.Clothing.LoungePants.prototype.updateThreeTexture = function(modelViewer) {
	if(!modelViewer.inlab && modelViewer.textureImage){
		if(!modelViewer.lightCanvas && modelViewer.lightImage){
			modelViewer.lightCanvas = document.createElement('canvas'); 
			modelViewer.lightCanvas.width = 2048;
			modelViewer.lightCanvas.height = 2048;
			lightCtx = modelViewer.lightCanvas.getContext('2d');
			lightCtx.putImageData(modelViewer.lightImage, 0, 0);
			var lightTexture = new THREE.Texture(modelViewer.lightCanvas);
			lightTexture.flipY = false;
			lightTexture.needsUpdate = true;
			modelViewer.object.children[this.outsideObject].material.metalness = 1;
			modelViewer.object.children[this.outsideObject].material.metalnessMap = lightTexture;
			modelViewer.object.children[this.outsideObject].material.roughnessMap = lightTexture;
		}
	}

	modelViewer.object.children[this.outsideObject].material.map = modelViewer.texture;
	modelViewer.object.children[this.outsideObject].material.map.flipY = false;
	modelViewer.object.children[this.outsideObject].material.map.needsUpdate = true;
	modelViewer.object.children[this.outsideObject].material.needsUpdate = true;

	modelViewer.object.children[this.elasticObject].material.map = modelViewer.texture;
};

window.Products.Clothing.LoungePants.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.8;
	controls.maxDistance = 4;
};

window.Products.Clothing.LoungePants.prototype.setThreeView = function(camera, view, zoom) {
	if(!zoom) zoom = 0;
	this.parent.parent.setThreeView(camera, view, zoom * -1);
};